import React from "react";

const CategoryDropdownStructure = ({ selectHandler, elValue}) => {
    const CourseStructures = ["Category", "Lesson"]
    
return (
    
    <select value={elValue} 
    name="category" 
    id="category" 
    className="min-w-[10rem] px-3 py-2 text-sm font-semibold"
    onChange={selectHandler}
>


{CourseStructures.map(
    (les,i) => 
        {
            return (
                <option value={les} key={les}>
                    {les}
                </option>
            );
        }
    )
}           
</select>
    
    
    
    
    
   
  );
};


export default CategoryDropdownStructure;
